import React from 'react';
import { Tooltip } from '@onward-delivery/design';
import Pill from '../Pill';
import { NOT_CONNECTED_LABEL, TMS_TONES } from '../constants';

// The column is 160px wide, which fits one TMS name and a count, not two names.
const TmsCell = ({ row }) => {
    const { tmsTags } = row.original;
    if (!tmsTags.length) {
        return <span className="text-[12px] text-muted">{NOT_CONNECTED_LABEL}</span>;
    }

    const [shown, ...hidden] = tmsTags;
    const shownTag = <Pill tone={TMS_TONES[shown.type] || 'tms'}>{shown.label}</Pill>;
    if (!hidden.length) return shownTag;

    const hiddenLabels = hidden.map((tag) => tag.label).join(', ');

    return (
        <div className="flex items-center justify-center gap-1">
            {shownTag}
            <Tooltip content={hiddenLabels}>
                {/* The trigger needs a DOM element to attach to; Pill does not forward refs. */}
                <span tabIndex={0}>
                    <Pill tone="tms">+{hidden.length}</Pill>
                </span>
            </Tooltip>
        </div>
    );
};

export default TmsCell;
